import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateClientComponent } from '@shared/components/create-client/create-client.component';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CreateClientModalService {
  createClient(): Subject<any> {
    const confirmSubject = new Subject();

    const dialogRef = this.dialog.open(CreateClientComponent, {
      width: 'md',
      panelClass: 'reset-mat-modal',
      data: {
        subject: confirmSubject
      }
    });

    const subscriber = dialogRef.backdropClick().subscribe(() => {
      confirmSubject.next({
        width: 'md',
        confirmed: false,
        modal: dialogRef
      });
      dialogRef.close();
      subscriber.unsubscribe();
    });

    return confirmSubject;
  }

  constructor(private dialog: MatDialog) {}
}
